import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useMutation } from 'react-query';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Redirect } from 'react-router-dom';

import Button from '../../../components/Button';
import usernameSvg from '../../../assets/images/username.svg';
import passwordSvg from '../../../assets/images/password.svg';

import './css/signin.css';

export default function Loginform() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [checked, setChecked] = useState(false);

  const [mutate, { isLoading, isSuccess, data, error }] = useMutation(
    async (data) => {
      const response = await fetch(
        'https://testapi.hendrayfinvest.com/oauth/token',
        {
          method: 'POST',
          mode: 'cors',
          cache: 'no-cache',
          headers: {
            'content-Type': 'application/json',
          },
          body: JSON.stringify({
            ...data,
            grant_type: 'password',
            client_id: '2',
            client_secret: 'xiG8beBLKODIQDn3aPUJT8rJzXwsR96em4tjpi73',
            provider: 'users',
          }),
        }
      ).then((res) => res.json());
      return response;
    }
  );
  const onSubmit = (e) => {
    e.preventDefault();
    console.log({
      username,
      password,
    });
    mutate({
      username,
      password,
    });
  };
  return (
    <form onSubmit={onSubmit}>
      {data && data.status === 'error' && <p>An error occurred</p>}
      {isSuccess && <Redirect to={{ pathname: '/account' }} />}
      <div className="formGrid">
        <div className="form-field input-icons">
          <img src={usernameSvg} alt="username icon" />
          <input
            value={username}
            placeholder="Username"
            className="formIn input-field"
            onChange={(e) => setUsername(e.currentTarget.value)}
            type="text"
          />
        </div>
        <div className="form-field input-icons">
          <img src={passwordSvg} alt="password icon" />
          <input
            placeholder="Password"
            className="formIn"
            value={password}
            onChange={(e) => setPassword(e.currentTarget.value)}
            type="password"
          />
        </div>
      </div>
      <div className="remfor">
        <div className="in">
          <input
            type="checkbox"
            defaultChecked={checked}
            onChange={() => setChecked(!checked)}
          />
          Remember me
        </div>
        <div>
          <a href="/" className="right-floater">
            <Link to="/reset">Forget Password?</Link>
          </a>
        </div>
      </div>
      <div className="formFlex topAcc">
        <Button className="signin-submit">
          <div style={{ color: '#fff' }}>
            {isLoading && <CircularProgress size={20} color="inherit" />}
          </div>
          {!isLoading && <span>Sign In</span>}
        </Button>
      </div>
    </form>
  );
}
